<template>
	<div>
		<div v-if="page.slug === '404'">
			<heading-image
				v-if="page.headingImage"
				:heading-image="{
					image: page.headingImage,
					imageWebp: page.headingImageWebp,
					imagePortrait: page.headingImagePortrait,
					imagePortraitWebp: page.headingImagePortraitWebp,
				}"
			/>
			<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />
			<div class="pagenotfound">
				<main-content
					:title="page.title || page.header"
					:subtitle="page.subtitle"
					:content="page.content"
					:introduction-content="page.introductionContent"
				/>
			</div>
		</div>
		<div v-else>
			<slot />
		</div>
	</div>
</template>

<script setup>
defineProps({
	page: { type: Object, default: () => {} },
	locale: { type: Object, default: () => {} },
});
</script>

<style lang="scss" scoped>
.pagenotfound {
	min-height: 50vh;
	background: #d68d0e;
}
</style>
